import { CSSProperties } from "react";

import { spacing } from "@layout";

export const ssnRouteStyles: Record<string, CSSProperties> = {
  footer: {
    display: "flex",
    flexDirection: "column",
  },
  footerContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 0,
    marginBottom: spacing.m,
  },
  footerText: {
    marginLeft: spacing.xs,
  },
};
